import { lazyInject } from '@intelingu/core/IoC/container';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { AppStore, ConnectionError } from '../../stores/AppStore';
import withTranslation from '@intelingu/core/utils/withTranslation';

export interface ConnectionErrorMessageProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class ConnectionErrorMessage extends Component<ConnectionErrorMessageProps, any> {

    @lazyInject(AppStore) appStore: AppStore;

    _renderMessage() {
        const { t } = this.props;

        switch (this.appStore.connectionError) {
            case ConnectionError.NETWORK_ERROR:
                return t('errorNetwork');
            case ConnectionError.TIMEOUT_ERROR:
                return t('errorTimeout');
            default:
                return null;
        }
    }

    render() {
        const { t } = this.props;

        return <div className={`top-alert error ${this.appStore.connectionError ? 'active' : ''}`}
                    onClick={() => this.appStore.resetConnectionError()}>
            { this.appStore.connectionError && (
                <>
                    <span>{ this._renderMessage() }</span>
                    <div style={{ marginTop: 5 }}>
                        <button className={'btn btn-danger'} onClick={() => this.appStore.connectionError = null}>{ t('close') }</button>
                    </div>
                </>
            ) }
        </div>;
    }

}
